import { Program } from '../../../../pages/eligibility/types';
import { ParentInfoType } from '../../../../pages/employees/types';
import { TotalResponse } from '../../../../pages/questionnaire/QuestionnaireClientInfo';
import { ApiMessage, ApiResponseHandler } from '../../../ApiResponseHandler';
import ThomApiClient from '../../../ThomApiClient';
import { InatkeParentType } from '../Intake/IntakeServices';
import { REFERRAL_PROGRAM_KEY, THOM_BASE_URL } from '../../../Constant';

export type Asqse2ListType = {
  id: string;
  age: number;
  dateOfAsqse2: string;
};

export type Asqse2CreateResponseType = {
  id: string;
};

export interface QuestionnaireClientInfoFormData {
  id?: string;
  age?: number;
  clientInfo?: {
    firstName: string;
    middleName: string;
    lastName: string;
    suffix: string;
    sex: string;
    dphId: string;
    dob: string | null;
  };
  defaultParent: string;
  parentDescription: string;
  prematureWeeks: string;
  asqCompletion: string | null;
  prematureMonths: string | null;
  prematureDays: string | null;
  ageAtAdministration: string | null;
  parentInfo?: ParentInfoType[];
  selectedParentInfo?: ParentInfoType;
  programDetails?: Program;
  parentContacts?: InatkeParentType[];
  otherName: string;
}

export const getAsqse2List = async (): Promise<Asqse2ListType[]> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Asqse2ListType[]>(
      `asqse2/all?referralProgramId=${referralProgramId ?? ''}`,
    ),
  );
};

export const getAsqse2 = async (): Promise<TotalResponse> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<TotalResponse>(
      `asqse2/default-data?referralProgramId=${referralProgramId ?? ''}`,
    ),
  );
};

export const getAsqse2ById = async (
  asqse2Id: string,
): Promise<TotalResponse> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<TotalResponse>(
      `asqse2/${asqse2Id}?referralProgramId=${referralProgramId ?? ''}`,
    ),
  );
};

export const downloadAsqse2ById = async (asqse2Id: string): Promise<Blob> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<Blob>(
      `asqse2/${asqse2Id}/download?referralProgramId=${
        referralProgramId ?? ''
      }`,
      {},
      {
        baseURL: THOM_BASE_URL,
        responseType: 'blob',
      },
    ),
  );
};

export const updateAsqse2 = async (
  asqse2Id: string,
  params: TotalResponse,
): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put<TotalResponse, ApiMessage>(
      `asqse2/${asqse2Id}?referralProgramId=${referralProgramId ?? ''}`,
      params,
    ),
  );
};

export const createAsqse2 = async (
  params: TotalResponse,
): Promise<Asqse2CreateResponseType> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post<
      TotalResponse,
      Asqse2CreateResponseType
    >(`asqse2?referralProgramId=${referralProgramId ?? ''}`, params),
  );
};

export const deleteAsqse2 = async (asqse2Id: string): Promise<ApiMessage> => {
  const referralProgramId = localStorage.getItem(REFERRAL_PROGRAM_KEY);
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete<ApiMessage>(
      `asqse2/${asqse2Id}?referralProgramId=${referralProgramId ?? ''}`,
    ),
  );
};
